export const bankAccountTypes = [
    { label: 'Checking', value: 'Checking' },
    { label: 'Savings', value: 'Savings' }
];
